const solverIcons = {
  exploreModules: "ph:paper-plane-tilt",
  knowledgeCafe: "ph:coffee",
  myCohort: "ph:users-three",
  myProfile: "ph:user-gear",
  trainingPlan: "ph:rocket-launch",
};

const appSettingsIcons = {
  platform: "ph:app-window",
  content: "ph:scribble-loop",
  user: "ph:identification-badge",
  security: "ph:lock",
};

const userSettingsIcons = {
  general: "ph:user-rectangle",
  notifications: "ph:bell-ringing",
  security: "ph:key",
  myProfile: "ph:user",
}

const otherIcons = {
  arrowRight: "ph:arrow-right",
  close: "ph:x",
  save: "ph:floppy-disk",
  success: "ph:check-circle",
  passwordView: "eva:eye-fill",
  passwordHide: "eva:eye-off-fill",
};

export const piccIcons = {
  solver: solverIcons,
  appSettings: appSettingsIcons,
  userSettings: userSettingsIcons,
  other: otherIcons,
};
